import { render, staticRenderFns } from "./reg_footer.vue?vue&type=template&id=0a21ca82&scoped=true"
import script from "./reg_footer.vue?vue&type=script&lang=js"
export * from "./reg_footer.vue?vue&type=script&lang=js"
import style0 from "./reg_footer.vue?vue&type=style&index=0&id=0a21ca82&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a21ca82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a21ca82')) {
      api.createRecord('0a21ca82', component.options)
    } else {
      api.reload('0a21ca82', component.options)
    }
    module.hot.accept("./reg_footer.vue?vue&type=template&id=0a21ca82&scoped=true", function () {
      api.rerender('0a21ca82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/landingpage/reg_footer.vue"
export default component.exports